/******
 *
 * How is PE ratio calculated?
To calculate the P/E ratio, divide the company's stock price by its earnings per share (EPS) (usually the market uses diluted earnings per share). */

import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import {
  Box,
  createTheme,
  Stack,
  Typography,
  Grid,
  IconButton,
} from "@mui/material";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import ViewListIcon from "@mui/icons-material/ViewList";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import axios from "axios";
import { tableCellClasses } from "@mui/material/TableCell";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  mode: "dark",
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: theme.palette.common.black,
    // color: theme.palette.common.white,
    fontSize: 12,
    fontFamily: "public sans",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    fontFamily: "public sans",
  },
}));

const PToEChart = ({
  reportedFinancials,
  mode,
  financialPeriod,
  token,
  symbol,
}) => {
  const [dataView, setDataView] = useState(false);
  const [growthData, setGrowthData] = useState();
  const [timePeriods, setTP] = useState([]);
  const [priceToEarningsRatio, setPE] = useState([]);

  useEffect(() => {
    if (financialPeriod == "quarterly") {
      //   console.log("reported financials", reportedFinancials);
      const fetchChart = async (fetchDate) => {
        let x = await axios.get(
          `https://cloud.iexapis.com/stable/stock/${symbol}/chart/date/${fetchDate}?chartCloseOnly=true&&chartByDay=true&&token=${token}`
        );
        return x;
      };
      const getMarketSharePrice = async (periodEnd) => {
        let chartData = {};
        let periodEndDate = new Date(periodEnd);
        //   console.log("dateForFetch", dateForFetch, symbol, token);

        let i = 0;
        while (i < 4) {
          let year = periodEndDate.getUTCFullYear();
          let month = periodEndDate.getUTCMonth() + 1;
          let day = periodEndDate.getUTCDate() - i;
          if (month < 10) {
            month = "0" + month.toString();
          }
          if (day < 10) {
            day = "0" + day.toString();
          }
          let dateForFetch = parseInt(
            year?.toString() + month?.toString() + day?.toString()
          );
          // console.log("turn", i, " fetch date", dateForFetch);
          /********* */
          chartData = await fetchChart(dateForFetch);
          if (chartData?.data?.length > 0) {
            //   console.log("chart data", chartData?.data);
            i = 4;
            return chartData?.data[0]?.date ? chartData?.data[0] : {};
          }

          /********* */
          i++;
        }
      };

      const calculatePToE = async () => {
        if (reportedFinancials?.quarterly?.length > 0) {
          let temp = [];
          reportedFinancials?.quarterly.map(async (fin, i) => {
            let p = fin?.periodEnd;
            let price = await getMarketSharePrice(p);
            let EPS = fin?.EarningsPerShareDiluted
              ? fin?.EarningsPerShareDiluted
              : fin?.EarningsPerShareBasicAndDiluted;

            let pToE = price?.close / EPS;
            // console.log(
            //   "wuarterly",
            //   "i",
            //   i,
            //   "price",
            //   price?.close,
            //   "eps",
            //   EPS,
            //   "ptoe",
            //   pToE
            // );
            if (pToE) {
              let obj = {
                fiscalPeriod: fin?.DocumentFiscalPeriodFocus
                  ? `FY${fin?.DocumentFiscalYearFocus - 2000} ${
                      fin?.DocumentFiscalPeriodFocus
                    }`
                  : fin?.fiscalQuarter
                  ? `FY${fin?.fiscalYear - 2000} Q${fin?.fiscalQuarter}`
                  : fin?.formFiscalYear
                  ? `FY${fin?.formFiscalYear - 2000} Q${fin?.formFiscalQuarter}`
                  : `FY Q `,
                pToE: pToE,
                index: i,
              };
              temp?.push(obj);

              let sortedData = temp.sort((a, b) => {
                return b.index - a.index;
              });

              setTP(sortedData.map((t) => t?.fiscalPeriod));
              setPE(sortedData.map((t) => t?.pToE.toFixed(2)));
            }
          });
        }
      };
      calculatePToE();
    } else {
      // console.log("reported financials", reportedFinancials);
      const fetchChart = async (fetchDate) => {
        let x = await axios.get(
          `https://cloud.iexapis.com/stable/stock/${symbol}/chart/date/${fetchDate}?chartCloseOnly=true&&chartByDay=true&&token=${token}`
        );
        return x;
      };
      const getMarketSharePrice = async (periodEnd) => {
        let chartData = {};
        let periodEndDate = new Date(periodEnd);
        //   console.log("dateForFetch", dateForFetch, symbol, token);

        let i = 0;
        while (i < 4) {
          let year = periodEndDate.getUTCFullYear();
          let month = periodEndDate.getUTCMonth() + 1;
          let day = periodEndDate.getUTCDate() - i;
          if (month < 10) {
            month = "0" + month.toString();
          }
          if (day < 10) {
            day = "0" + day.toString();
          }
          let dateForFetch = parseInt(
            year?.toString() + month?.toString() + day?.toString()
          );
          // console.log("turn", i, " fetch date", dateForFetch);
          /********* */
          chartData = await fetchChart(dateForFetch);
          if (chartData?.data?.length > 0) {
            //   console.log("chart data", chartData?.data);
            i = 4;
            return chartData?.data[0]?.date ? chartData?.data[0] : {};
          }

          /********* */
          i++;
        }
      };

      const calculatePToE = async () => {
        if (reportedFinancials?.annual?.length > 0) {
          let temp = [];
          reportedFinancials?.annual.map(async (fin, i) => {
            let p = fin?.periodEnd;
            let price = await getMarketSharePrice(p);
            let EPS = fin?.EarningsPerShareDiluted
              ? fin?.EarningsPerShareDiluted
              : fin?.EarningsPerShareBasicAndDiluted;
            let pToE = price?.close / EPS;
            // console.log(
            //   "annual",
            //   "i",
            //   i,
            //   "price",
            //   price?.close,
            //   "eps",
            //   EPS,
            //   "ptoe",
            //   pToE
            // );
            if (pToE) {
              let obj = {
                fiscalPeriod: fin?.DocumentFiscalYearFocus
                  ? `${fin?.DocumentFiscalYearFocus} `
                  : fin?.fiscalYear
                  ? `${fin?.fiscalYear}`
                  : `${fin?.formFiscalYear} `,
                pToE: pToE,
                index: i,
              };
              temp?.push(obj);

              let sortedData = temp.sort((a, b) => {
                return b.index - a.index;
              });

              setTP(sortedData.map((t) => t?.fiscalPeriod));
              setPE(sortedData.map((t) => t?.pToE.toFixed(2)));
            }
          });
        }
      };
      calculatePToE();
    }
  }, [reportedFinancials, financialPeriod]);

  var options = {
    series: [
      {
        name: "P/E",
        data: priceToEarningsRatio,
      },
    ],
    chart: {
      type: "line",
      height: 1400,
      background: "transparent",
      toolbar: {
        show: true,

        tools: {
          download: true,
          selection: window?.screen?.width > 600 ? true : false,
          zoom: window?.screen?.width > 600 ? true : false,
          zoomin: window?.screen?.width > 600 ? true : false,
          zoomout: window?.screen?.width > 600 ? true : false,
          pan: window?.screen?.width > 600 ? true : false,
          reset: window?.screen?.width > 600 ? true : false,
        },
        export: {
          csv: {
            filename: financialPeriod + " - Price To Earnings Ratio",
            columnDelimiter: ",",
            headerCategory: "Financial Period",
            headerValue: "value",
            dateFormatter(timestamp) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: financialPeriod + " - Price To Earnings Ratio",
          },
          png: {
            filename: financialPeriod + " - Price To Earnings Ratio",
          },
        },
      },
    },
    colors: ["#fcc432", "#CA955C"],

    stroke: {
      curve: "smooth",
      width: window?.screen?.width > 600 ? 5 : 3,
      lineCap: "butt",
      colors: ["#fcc432", "#CA955C"],
      // OR provide an array
      // curve: ["smooth", "straight", "stepline"],
    },
    //   plotOptions: {
    //     bar: {
    //       horizontal: false,
    //       columnWidth: "75%",
    //       endingShape: "rounded",
    //     },
    //   },
    dataLabels: {
      enabled: false,
    },
    // stroke: {
    //   show: true,
    //   width: 2,
    //   colors: ["transparent"],
    // },
    legend: {
      show: true,
      showForSingleSeries: false,
      showForNullSeries: true,
      showForZeroSeries: true,
      position: "top",
      horizontalAlign: "center",
      floating: false,
      fontSize: window?.screen?.width > 600 ? "14px" : "10px",
      fontFamily: "public sans",
      fontWeight: 400,
      labels: {
        useSeriesColors: true,
      },

      itemMargin: {
        horizontal: 5,
        vertical: 5,
      },
      onItemClick: {
        toggleDataSeries: true,
      },
      onItemHover: {
        highlightDataSeries: true,
      },
    },
    grid: {
      show: true,
      borderColor: mode == "light" ? "#d9d9d999" : "#d9d9d955",
      row: {},
      xaxis: {
        lines: {
          show: false,
        },
        position: "top",
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    theme: {
      mode: mode,
      //   palette: "palette5",
    },
    xaxis: {
      lines: {
        show: false, //or just here to disable only y axis
      },
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: false,
      },
      // axisBorder: {
      //   show: true,
      //   color: "#78909C",
      //   height: 1,
      //   width: "100%",
      //   offsetX: 0,
      //   offsetY: 0,
      // },
      // axisTicks: {
      //   show: true,
      //   borderType: "solid",
      //   color: "#78909C",
      //   height: 6,
      //   offsetX: 0,
      //   offsetY: 0,
      // },

      categories: timePeriods,
      labels: {
        show: true,
        rotate: -50,
        rotateAlways: window?.screen?.width > 768 ? false : true,
        hideOverlappingLabels: true,
        showDuplicates: false,
        trim: false,
        maxHeight: 120,
        style: {
          color: new Array(timePeriods?.length)?.fill("#ff0000"),
          fontSize: "10px",
          fontFamily: "public sans",
          fontWeight: 400,
          cssClass: "apexcharts-xaxis-label",
        },
        offsetX: 0,
        offsetY: 0,
      },
    },
    yaxis: {
      tickAmount: 10,
      title: {
        text: "",
      },
      labels: {
        formatter: function (value) {
          return value.toFixed(2);
        },
        style: {
          colors: [],
          fontSize: "10px",
          fontFamily: "public sans",
          fontWeight: 400,
          cssClass: "apexcharts-yaxis-label",
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return "" + val?.toFixed(2);
        },
      },
    },
  };
  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 12,
      fontFamily: "public sans",
      fontWeight: 300,
    },
  }));

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
      backgroundColor: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 12,
      fontWeight: 300,
      fontFamily: "public sans",
    },
  }));
  const [chartDescription, x] = useState(
    " The P/E ratio is calculated by dividing the market value price per share by the company's earnings per share. Earnings per share (EPS) is the amount of a company's profit allocated to each outstanding share of a company's common stock, serving as an indicator of the company's financial health."
  );

  return (
    <div>
      <Box
        sx={{
          fontFamily: "public sans",
          fontSize: "2rem",
          color: "fontPrimaryColor.main",
        }}
        className="chart__title"
      >
        P/E Ratio
      </Box>
      {dataView ? (
        <Box
          sx={{
            minWidth: "300px",
            marginLeft: "50%",
            transform: "translateX(-50%)",
          }}
          onClick={() => console.log("option.series", options?.series)}
        >
          <TableContainer component={Paper}>
            <Table
              sx={{
                minWidth: 50,
                fontFamily: "public sans",
              }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead
                sx={{
                  backgroundColor: "bgSecondary.main",
                  color: "fontSecondaryColor.main",
                }}
              >
                <TableRow
                  sx={{
                    backgroundColor: "bgSecondary.main",
                  }}
                >
                  <StyledTableCell
                    sx={{
                      color: "fontPrimaryColor.main",
                    }}
                  >
                    Financial Period
                  </StyledTableCell>
                  <StyledTableCell
                    sx={{
                      color: "fontPrimaryColor.main",
                    }}
                    align="right"
                  >
                    P/E
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {new Array(timePeriods?.length).fill("1").map((row, i) => (
                  <TableRow
                    key={timePeriods[i]}
                    sx={{
                      backgroundColor: "bgPrimary.main",
                      boxShadow:
                        mode == "dark"
                          ? "#888 0px 0px 0px 1px"
                          : "#e6e6e6 0px 0px 0px 1px",
                    }}
                  >
                    <StyledTableCell
                      sx={{
                        color: "fontSecondaryColor.main",
                        borderBottom: "none",
                      }}
                      component="th"
                      scope="row"
                    >
                      {timePeriods[i]}
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{
                        color: "fontSecondaryColor.main",
                        borderBottom: "none",
                      }}
                      align="right"
                    >
                      {numFormatter(options?.series[0]?.data[i])}
                    </StyledTableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : (
        <Chart
          options={options}
          series={options?.series}
          type="line"
          height={window?.screen?.width > 600 ? "200%" : "150%"}
          width="100%"
        />
      )}

      <Box className="chart__bottom__options__bar" sx={{ gap: "10px" }}>
        <Box
          className="showChartInfoBtn"
          sx={{ backgroundColor: "bgSecondary.main", borderRadius: "50%" }}
        >
          {mode == "dark" ? (
            <LightTooltip title={chartDescription} arrow>
              <Box>
                <QuestionMarkIcon
                  sx={{ color: "fontSecondaryColor.main", fontSize: "20px" }}
                />
              </Box>
            </LightTooltip>
          ) : (
            <BootstrapTooltip title={chartDescription} arrow>
              <QuestionMarkIcon
                sx={{ color: "fontSecondaryColor.main", fontSize: "20px" }}
              />
            </BootstrapTooltip>
          )}
        </Box>
        <Box onClick={() => setDataView(!dataView)}>
          <IconButton sx={{ backgroundColor: "bgSecondary.main" }}>
            <ViewListIcon
              sx={{ color: "fontSecondaryColor.main", fontSize: "20px" }}
            />
          </IconButton>
        </Box>
      </Box>
    </div>
  );
};

export default PToEChart;
function numFormatter(num) {
  if (num > 999 && num < 1000000) {
    return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
  } else if (num > 1000000000000) {
    return (num / 1000000000000).toFixed(2) + "T"; // convert to M for number from > 1 million
  } else if (num > 100000000) {
    return (num / 1000000000).toFixed(2) + "B"; // convert to M for number from > 1 million
  } else if (num > 1000000) {
    return (num / 1000000).toFixed(2) + "M"; // convert to M for number from > 1 million
  } else if (num < 900 && num > 0) {
    return num; // if value < 1000, nothing to do
  } else if (num < -999 && num > -1000000) {
    return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
  } else if (num < -1000000000000) {
    return (num / 1000000000000).toFixed(2) + "T"; // convert to M for number from > 1 million
  } else if (num < -100000000) {
    return (num / 1000000000).toFixed(2) + "B"; // convert to M for number from > 1 million
  } else if (num < -1000000) {
    return (num / 1000000).toFixed(2) + "M"; // convert to M for number from > 1 million
  } else if (num > -900) {
    return num; // if value < 1000, nothing to do
  }
}
